import { useEffect, useMemo, useRef } from "react";
import { useConfigStore } from "../../../../../../stores/ConfigStore";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { getFields } from "../../../../../../api/ContactAPI";
import { Button, Divider, Flex, Group, Stack } from "@mantine/core";
import TextEditor from "../../../../../../components/ExternalEditors/TextEditor";
import BackButton from "../../../../../../components/View/BackButton";
import { IconSend } from "@tabler/icons-react";
import ReplyGenerator from "../../../../models/emails/ReplyGenerator";
import { getPermission } from "../../../../../../functions/utilFunctions";
import ModelTemplateSender from "../../../../models/ModelTemplateSender";

const LinkedinAnswerEditorMobile = ({
  id,
  handleClose,
  handleSubmit,
  onInit,
  loading,
  disabled,
  isInvitation,
  lastLinkedinReply,
}) => {
  const lang = useLanguage((s) => s.language);
  const editorRef = useRef();

  const datafields = useConfigStore((s) => s.datafields);
  const datafieldTokens = useMemo(() => {
    let df = datafields.map((x) => ({
      label: x.name,
      value: x.identifier_placeholder,
    }));

    df = [
      {
        label: lang.components.variable_manager.dialog.signature_variable_name,
        value: "%signature%",
        name: lang.components.variable_manager.dialog.signature_variable_name,
      },
      ...df,
    ];

    return df;
  }, [datafields, lang]);

  useEffect(() => {
    getFields();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    let text = "";

    text = editorRef?.current?.getContent({ format: "text" });

    return handleSubmit({
      text,
    });
  };

  const onGenerated = (text) => {
    editorRef.current?.setContent(text);
  };

  const onImport = (model) => {
    editorRef.current?.setContent(model.text);
  };

  return (
    <Stack
      component={"form"}
      onSubmit={onSubmit}
      gap={0}
      id="model-form"
      w={"100%"}
      pos={"relative"}
      style={{ border: "1px solid #00000012", borderRadius: 8 }}
      h={"60vh"}
    >
      <TextEditor
        id={id}
        editorRef={editorRef}
        placeholder={lang.resellers.messages.message_placeholder}
        tokens={datafieldTokens}
        toolbar={"undo"}
        toolbarButtonsOpacity={0}
        autoFocus
        // autoSize
        disableDecor
        onInit={onInit}
        maxChars={9999}
        isMobile
        isLinkedin
      ></TextEditor>

      <Divider opacity={0.5} />

      <Group py={8} justify="end">
        {/* <Flex mr={"auto"}>
          <ModelTemplateSender
            type={isInvitation ? "linkedin_invitation" : "linkedin_message"}
            onImport={onImport}
          />
        </Flex> */}

        <BackButton
          onClick={handleClose}
          label={lang.global.cancel}
          size="md"
        />

        <Button
          type="submit"
          rightSection={<IconSend size={18} />}
          size="md"
          loading={loading}
          disabled={disabled}
        >
          {lang.global.send}
        </Button>
      </Group>
    </Stack>
  );
};

export default LinkedinAnswerEditorMobile;
